const WPForms = () => {

	const handleSubmitSuccess = (e) => {
		const formElement = e.currentTarget;
		const formContainer = formElement.parentNode;
		const formHeight = formElement.offsetHeight;
		formContainer.style.height = `${formHeight / 10}rem`;
	};

	// Setup callback on each WPForms form. TODO: Does it still require jQuery?!
	document.querySelectorAll('.wpforms-form').forEach(wpform => {
		jQuery(wpform).off('wpformsAjaxSubmitSuccess', handleSubmitSuccess); // Remove any callback that may have been set
		jQuery(wpform).on('wpformsAjaxSubmitSuccess', handleSubmitSuccess);
	});
}

export default WPForms;